import { cn } from "@/lib/utils";
import type { ChannelStatus } from "@/types/homepage";

/** LIVE / Early Access pill in brand colors. */
const StatusBadge = ({
  status,
  className,
}: {
  status: ChannelStatus;
  className?: string;
}) => {
  const isLive = status === "live";

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide",
        isLive
          ? "bg-genie-primary/10 text-genie-primary"
          : "bg-genie-accent/15 text-genie-accent-dark",
        className
      )}
    >
      <span
        className={cn(
          "h-1.5 w-1.5 rounded-full",
          isLive ? "bg-genie-primary" : "bg-genie-accent-dark"
        )}
      />
      {isLive ? "Live now" : "Early access"}
    </span>
  );
};

export default StatusBadge;
